import styled, { createGlobalStyle } from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  top: 115px;
  left: 60px;
  width: calc(100vw - 60px);
  height: calc(100vh - 180px);

  ${mediaMaxWidth.tablet`
    top: 55px;
    left: 0px;
    width: 100vw;
    height: calc(100vh - 125px);
  `}
`;

export const Board = styled.div`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  ${mediaMaxWidth.phone`
    scroll-snap-type: ${(props) =>
      props.draggingActive ? "unset" : "x mandatory"};
    -webkit-overflow-scrolling: ${(props) =>
      props.draggingActive ? "unset" : "touch"};
    -ms-scroll-snap-type: ${(props) =>
      props.draggingActive ? "unset" : "mandatory"};
    scroll-snap-points-x: ${(props) =>
      props.draggingActive ? "unset" : "repeat(100%)"};
    -ms-scroll-snap-points-x: ${(props) =>
      props.draggingActive ? "unset" : "repeat(100%)"};
  `}
`;

export const GlobalStyle = createGlobalStyle`
  body#recruiter-kanban,
  body#employer-kanban {
    #main-wrapper {
      height: 100vh;
    }

    .main-content-wrapper {
      height: 100%;
      background: unset;
    }

    &.candidates-tab {
      #kanban-how-to {
        display: flex;

        ${mediaMaxWidth.smallDesktop`
          display: none;
        `}
      }
    }
  }

  ${mediaMaxWidth.tablet`
    body.tab-nav-active {
      #navbar {
        display: none;
        transition: 0s;
      }

      #action-bar {
        top: 0;
        transition: 0s;
      }

      #tab-nav {
        top: 57px;
        transition: 0s;
      }

      #mobile-bottom-nav {
        display: none;
      }
    }
  `}
`;
